import { render } from "./Work3Header.vue?vue&type=template&id=3ede3698&scoped=true"
import script from "./Work3Header.vue?vue&type=script&lang=js"
export * from "./Work3Header.vue?vue&type=script&lang=js"

import "./Work3Header.vue?vue&type=style&index=0&id=3ede3698&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ede3698"]])

export default __exports__